<header class="header-holder">
  <div>
    <p><a href="#main-content" spbAccessibleLink>Hoppa
      till innehåll</a></p>
    <spb-logo/>
  </div>

  <div>
    <spb-toggle-button/>
  </div>
</header>